<template>
  <RevDialog :name="MODAL_NAME" :title="i18n(translations.modalTitle)">
    <template #body>
      {{ i18n(translations.deletionMessage) }}
    </template>
    <template #footer>
      <div class="flex flex-col items-center">
        <RevButton
          class="mb-8"
          full-width="always"
          :loading="isSubmitting"
          variant="primary"
          @click="handleSubmit"
        >
          {{ i18n(translations.confirmDelete) }}
        </RevButton>
        <RevLink class="mt-12" @click="handleCloseModal">
          {{ i18n(translations.cancelDelete) }}
        </RevLink>
      </div>
    </template>
  </RevDialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { sellerProfileAPI } from '@backmarket/http-api'
import type { GetEprInformationItem } from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-profile'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'
import { RevLink } from '@ds/components/Link'
import { closeModal } from '@ds/components/ModalBase'

import { MODAL_NAMES } from '../../../../../../Profile.constants'

import translations from './EprDetailDeletionConfirmModal.translations'

const MODAL_NAME = MODAL_NAMES.DELETE_EPR_DETAIL

const props = defineProps<{
  eprDetailId: GetEprInformationItem['id']
}>()

const emit = defineEmits(['update-epr-imformation'])

const i18n = useI18n()
const { openErrorToast, openSuccessToast } = useTheToast()

const isSubmitting = ref(false)

function handleCloseModal() {
  closeModal(MODAL_NAME)
}

async function handleSubmit() {
  isSubmitting.value = true
  try {
    await $httpFetch(sellerProfileAPI.deleteEprInformation, {
      pathParams: { id: props.eprDetailId },
    })
    openSuccessToast({
      title: i18n(translations.eprInformationDeleteSuccessTitle),
      content: i18n(translations.eprInformationDeleteSuccessMessage),
    })
    emit('update-epr-imformation')
  } catch {
    openErrorToast({
      title: i18n(translations.eprInformationDeleteErrorTitle),
      content: i18n(translations.eprInformationDeleteErrorMessage),
    })
  } finally {
    isSubmitting.value = false
    closeModal(MODAL_NAME)
  }
}
</script>
